import { StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { COLOR } from 'utils/colors';

const styles = StyleSheet.create({
    marker: {
        width: 'auto',
        paddingHorizontal: 12,
        paddingVertical: 2,
        borderRadius: 20,
    },
    markerText: {
        alignSelf: 'center',
        fontFamily: Fonts.main.bold,
        fontSize: 12,
        color: COLOR.background,
    },
});

export default styles;
